import React from "react";
import Skeleton from "react-loading-skeleton";

function CardSkeleton({ baseColor }: { baseColor?: string }) {
  return (
    <div className="w-full grid  min-[1400px]:gap-3 xl:grid-cols-4 min-[900px]:grid-cols-3 min-[600px]:grid-cols-2 grid-cols-1 gap-5 sm:justify-between justify-center pb-5">
      <div className="mt-7 flex justify-center items-center ">
        <Skeleton
          height={400}
          className="normal-radius  w-[300px] mx-auto"
          width={300}
          baseColor={baseColor ?? ""}
        />
      </div>
      <div className="mt-7 flex justify-center items-center">
        <Skeleton
          height={400}
          className="normal-radius  w-[300px] mx-auto"
          width={300}
          baseColor={baseColor ?? ""}
        />
      </div>
      <div className="mt-7 flex justify-center items-center">
        <Skeleton
          height={400}
          className="normal-radius  w-[300px] mx-auto"
          width={300}
          baseColor={baseColor ?? ""}
        />
      </div>
      <div className="mt-7 flex justify-center items-center">
        <Skeleton
          height={400}
          className="normal-radius  w-[300px] mx-auto"
          width={300}
          baseColor={baseColor ?? ""}
        />
      </div>
      <div className="mt-7 flex justify-center items-center">
        <Skeleton
          height={400}
          className="normal-radius  w-[300px] mx-auto"
          width={300}
          baseColor={baseColor ?? ""}
        />
      </div>
      <div className="mt-7 flex justify-center items-center">
        <Skeleton
          height={400}
          className="normal-radius  w-[300px] mx-auto"
          width={300}
          baseColor={baseColor ?? ""}
        />
      </div>
      <div className="mt-7 flex justify-center items-center">
        <Skeleton
          height={400}
          className="normal-radius  w-[300px] mx-auto"
          width={300}
          baseColor={baseColor ?? ""}
        />
      </div>
      <div className="mt-7 flex justify-center items-center">
        <Skeleton
          height={400}
          className="normal-radius  w-[300px] mx-auto"
          width={300}
          baseColor={baseColor ?? ""}
        />
      </div>
    </div>
  );
}

export default CardSkeleton;
